const ITEMS = [
  "Rénovation complète",
  "Cuisines",
  "Salles de bains",
  "Peinture & revêtements",
  "Menuiserie & finitions",
  "Électricité",
  "Plomberie",
  "Genève et environs",
];

export const Marquee = () => {
  const sequence = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-slate-200 bg-white py-5"
    >
      <div className="animate-marquee-x flex w-max items-center">
        {sequence.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap px-8 font-display text-sm font-medium uppercase tracking-[0.3em] text-slate-400">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-sun" />
          </span>
        ))}
      </div>
    </div>
  );
};
